module.exports = __webpack_public_path__ + "static/sponsors-image-444691ee2ca8733d4bce19f314acd50b.png";